/* ⚛ REACT */
import {useState} from "react";

/* 🎨 STYLES */
import { Container, SideBarButton, Circle, Line} from "./styles";

/* 🔧 UTILS */
import { isValidaProp } from "../../../../util/validate";

const SideBarSubItem = (props) => {
    const Itens = isValidaProp(props.itens) ? props.itens : []
    const [hovered, setHovered] = useState(false);

    const changePage = (e, func)=>{
        e.preventDefault()
        func.locationFunction();
    }

    return(
        <Container>
            {Itens.map((item, index) =>{
                const subItemSelected = props.select.includes(item.page);
                return(
                    <SideBarButton 
                        href={item.page}
                        onMouseEnter={() => setHovered(index)} 
                        onMouseLeave={() => setHovered(null)}
                        key={index} 
                        onClick={(e) => !item.disabled && changePage(e, item)}
                        $isDisabled={item.disabled}
                        $isActive={props.active}
                        $isSelected={subItemSelected}
                        >

                        <Circle $isHovered={hovered === index} $isActive={props.active} $isSelected={subItemSelected} $isDisabled={item.disabled}/>

                        <Line/>
                        
                        {item.text}
                    </SideBarButton>
                )
            })}
        </Container>
    )
}

export default SideBarSubItem;